import { UseQueryResult, useQuery } from "react-query";
import {
  UpdateInvoiceInsuranceClaimNumberResponse,
  updateInvoiceInsuranceClaimNumber
} from "../../../../entities/invoice/api/update-insurance-claim-number";

interface UseUpdateInvoiceInsuranceClaimNumberProps {
  id: string;
  new_insurance_claim_number: string;
}

export const queryKeys = {
  updateInvoiceInsuranceClaimNumber: (props: UseUpdateInvoiceInsuranceClaimNumberProps) => ["updateInvoiceInsuranceClaimNumber", props]
};

export function useUpdateInvoiceInsuranceClaimNumber(
  props: UseUpdateInvoiceInsuranceClaimNumberProps
): UseQueryResult<UpdateInvoiceInsuranceClaimNumberResponse, Error> {
  return useQuery(queryKeys.updateInvoiceInsuranceClaimNumber(props), () => updateInvoiceInsuranceClaimNumber(props), {
    retry: false,
    refetchOnWindowFocus: false,
    enabled: props.id !== "" && props.new_insurance_claim_number.length > 0
  });
}
